import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { RolesModel } from '../models/roles';

@Injectable({
    providedIn: 'root'
})
export class RolesProvider {

    page = 1;
    getPaginationCount;
    roles: RolesModel[] = [];
    //   rewardSubCategories: RewardSubCategoryModel[] = [];
    //   rewardParentCategories = [];
    constructor(
        private apiService: ApiService,
        private toast: ToastClientService,
        private apiConfig: ApiConfiguration
    ) {
        this.getUserRoles()
    }

    getUserRoles(): void {
        this.apiService.getHeaders(this.apiConfig.configGetRoles).subscribe(
            (res: any) => {
                this.roles = res.body.data as RolesModel[];
            },err=>{
                this.toast.Error('Unable to get data');
            }
        );
    }

}
